// removed by extract-text-webpack-plugin
module.exports = {"picker":"_3YMVnu8zZf0qSG4XTCuiel","pick":"_39QQ7MURgMkl8s6YShr_t1"};


//////////////////
// WEBPACK FOOTER
// ./app/components/RecipePicker/style.scss
// module id = 1259
// module chunks = 0